import React, { ReactNode } from 'react'

interface Option {
  isSelected: boolean
  id: number
  text: string
  info: string
}

interface Question {
  title: string
  position: number
  type: 'textarea' | 'checkbox'
  complementaryInfo?: ReactNode
  placeholder?: string
  answer?: string
  options?: Option[]
}

export const questions: Question[] = [
  {
    position: 1,
    title: 'Por qual motivo você quer fazer terapia?',
    type: 'textarea',
    placeholder: 'Escreva o que você esta sentindo',
    complementaryInfo: (
      <p>
        Exemplos:
        <br />
        <i>"Terminei meu relacionamento"</i>
        <br />
        <i>"Olho no espelho e não gosto do que vejo"</i>
        <br />
        <i>"Estou estressada e não consigo produzir"</i>
      </p>
    ),
  },
  {
    position: 2,
    title: 'Qual a sua expectativa em relação ao terapeuta?',
    type: 'checkbox',
    options: [
      { 
        id: 1,
        isSelected: false,
        text: 'Prefiro que o terapeuta me guie com sugestões claras e específicas sobre o que fazer.',
        info: 'Estilo de condução: diretiva',
      },
      { 
        id: 2,
        isSelected: false,
        text: 'Gosto de guiar a conversa e decidir que tópicos explorar, com o apoio e a facilitação do terapeuta.',
        info: 'Estilo de condução: não-diretiva',
      },
    ],
  },
  {
    position: 3,
    title: 'O que você considera mais importante em terapia?',
    type: 'checkbox',
    options: [
      { 
        id: 1,
        isSelected: false,
        text: 'Lidar com desafios e situações do dia a dia.',
        info: 'Foco temporal: presente',
      },
      { 
        id: 2,
        isSelected: false,
        text: 'Entender como eventos passados influenciam o que sinto e faço hoje.',
        info: 'Foco temporal: passado',
      },
    ],
  },
  {
    position: 4,
    title: 'Que tipo de abordagem você prefere em uma sessão de terapia?',
    type: 'checkbox',
    options: [
      { 
        id: 1,
        isSelected: false,
        text: 'Explorar significados mais profundos, como sonhos ou metáforas, para compreender melhor minha vida.',
        info: 'Tipo de reflexão: simbólica',
      },
      { 
        id: 2,
        isSelected: false,
        text: 'Focar em questões práticas e soluções diretas.',
        info: 'Tipo de reflexão: concreta',
      },
    ],
  },
  {
    position: 5,
    title: 'O que você acha mais útil para mudar a sua vida?',
    type: 'checkbox',
    options: [
      { 
        id: 1,
        isSelected: false,
        text: 'Explorar os motivos internos e inconscientes por trás dos meus comportamentos.',
        info: 'Estilo de mudança: psicodinâmica'
      },
      { 
        id: 2,
        isSelected: false,
        text: 'Trabalhar diretamente para modificar meus comportamentos e hábitos.',
        info: 'Estilo de mudança: comportamental'
      },
    ],
  },
  {
    position: 6,
    title: 'O que parece ser mais importante de trabalhar em você?',
    type: 'checkbox',
    options: [
      { 
        id: 1,
        isSelected: false,
        text: 'Meus pensamentos e crenças, para entender como eles impactam a minha vida.',
        info: 'Foco de processamento: cognição'
      },
      { 
        id: 2,
        isSelected: false,
        text: 'Minhas emoções, para aprender a lidar e regulá-las de forma saudável.',
        info: 'Foco de processamento: emoção'
      },
    ],
  },
]